import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";

import style from "../assets/css/page/DashboardTeam.module.css";
import tinycolor from "tinycolor2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretUp,
  faEquals,
  faFrown,
  faFutbol,
  faGrin,
  faHandsHelping,
  faMeh,
  faMitten,
  faPlus,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import Loading from "../components/Loading";
import classNames from "classnames";

import { GET_TEAM, GET_TOURNAMENTS } from "../graphql/queries";
import Header from "../components/Header/Header";
import Match from "../components/Match";
import PositionTeam from "../components/Chart/PositionTeam";
import EfficiencyTeam from "../components/Chart/EfficiencyTeam";
import { Link } from "react-router-dom";
import CardPlayer from "../components/Card/CardPlayer";
import DataTeam from "../components/Chart/DataTeam";
import { socket } from "../config/socket";

function DashboardTeam() {
  const location = useLocation();
  const role = window.localStorage.getItem("role");
  const team = window.localStorage.getItem("team");
  const [matches, setMatches] = useState([]);
  const [playersOrder, setPlayersOrder] = useState([]);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [numRegPlayer, setNumRegPlayer] = useState(0);
  const teamLogin = JSON.parse(window.localStorage.getItem("team"));

  const { data, loading, error } = useQuery(GET_TEAM, {
    variables: {
      IdTeam: location.state?.id,
      State: "LIVE",
    },
  });
  const tournaments = useQuery(GET_TOURNAMENTS);

  useEffect(() => {
    if (data) {
      const { matchs, teamVisits } = data.team;
      let matches = matchs.concat(teamVisits);
      matches.sort((a, b) => {
        if (a.day > b.day) return 1;
        if (a.day < b.day) return -1;
        return 0;
      });
      setMatches(matches);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      let objPlayers = [...data?.team?.players];
      // console.log(objPlayers);
      const playerPosition = objPlayers.sort((a, b) => {
        if (a.position > b.position) {
          return 1;
        }
        if (a.position < b.position) {
          return -1;
        }
        return 0;
      });
      setPlayersOrder(playerPosition);
    }
  }, [data]);

  useEffect(() => {
    // setLoading(true);
    let idTeam = teamLogin?.id;

    if (idTeam) {
      socket.emit("totalPlayer", { idTeam }, (res) => {
        setTotalPlayers(res);
      });
      socket.emit("getNumRegisterPlayer", { idTeam }, (res) => {
        setNumRegPlayer(res);
      });
    }
  }, []);

  if (loading || tournaments.loading) return <Loading />;

  if (error)
    return (
      <div>
        <p>Lo sentimos a ocurrido un error al traer los datos</p>
      </div>
    );

  const calculatePointTotal = (games) => {
    const points = games * 3;
    return points;
  };

  const calculateAverageGoal = (goal, games) => {
    const average = goal / games;
    return average ? average.toFixed(1) : 0;
  };

  const calculateAverageGoalAgainst = (goal, games) => {
    const average = goal / games;
    return average ? average.toFixed(1) : 0;
  };

  const calculatePercent = () => {
    const points = data.team.general_table.pts;
    const total = calculatePointTotal(data.team.general_table.jj);
    const percent = (points * 100) / total;
    if (percent >= 0) {
      // setPercentTeam(percent);
      return [Math.round(percent)];
    }
    return [0];
  };

  const statusPoints = () => {
    const percent = calculatePercent();
    if (percent[0] >= 80) {
      return "success";
    }
    if (percent[0] < 50) {
      return "danger";
    }
    if (percent[0] >= 50 && percent[0] < 80) {
      return "warning";
    }
    return "";
  };

  const positions = () => {
    const pos = [];
    const dataPos = [data?.team?.positions];
    dataPos[0]?.data.forEach((data) => {
      pos.push(data.position);
    });
    return pos;
  };

  const redCards = () => {
    let totalCards = 0;
    const dataPlayer = data.team.players;
    dataPlayer.forEach((dataPlayer) => {
      totalCards += dataPlayer.redCard;
    });
    return totalCards ? totalCards : 0;
  };

  const yellowCards = () => {
    let totalCards = 0;
    const dataPlayer = data.team.players;
    dataPlayer.forEach((dataPlayer) => {
      totalCards += dataPlayer.yellowCard;
    });
    return totalCards ? totalCards : 0;
  };

  const IconPosition = (position) => {
    if (position?.length > 1) {
      const before = position[position?.length - 1].position;
      const current = position[position?.length - 2].position;

      if (before === current) {
        return faEquals;
      } else if (before < current) {
        return faCaretUp;
      } else {
        return faCaretDown;
      }
    }
    return null;
  };

  const PaintIcon = (position) => {
    if (position?.length > 1) {
      const before = position[position.length - 1].position;
      const current = position[position.length - 2].position;

      if (before <= current) {
        return "success";
      } else {
        return "danger";
      }
    }
    return "warning";
  };

  return (
    <div className={style.container}>
      <Header
        nameTeam={data.team.name}
        teamColor={data.team.colorShirt}
        tournament={tournaments.data.tournaments[0].name}
      />
      <div className={style.stadistic}>
        <div className={style.matches}>
          <p className={style.titleSection}>partidos</p>
          <div className={style.cards}>
            {matches &&
              matches.map((match) => (
                <Match
                  key={match.id}
                  match={match}
                  admin={role === "Admin" ? true : false}
                  tournament={tournaments.data.tournaments[0].name}
                />
              ))}
          </div>
        </div>
        <div className={style.analytics}>
          {tournaments.data.tournaments[0].registerPlayers && (
            <div className={style.contAlert}>
              <div className={style.addPlayerFree}>
                <p className={style.text}>
                  Atención hay jugadores libres en busca de un equipo. ¡Hecha un
                  vistazo!
                </p>
                <Link to="/freeplayers" className={style.linkFreePlayer}>
                  Ver todos
                </Link>
              </div>
            </div>
          )}
          <div className={style.contData}>
            <p className={style.titleSection}>Estadisticas</p>
            <div className={style.data}>
              <ItemInfo
                title="Posición actual"
                data={
                  data?.team?.positions?.data[
                    data?.team?.positions?.data.length - 1
                  ]?.position
                }
                desc={
                  data?.team?.positions?.data[
                    data?.team?.positions?.data.length - 1
                  ]?.position < 9
                    ? "Liguilla"
                    : "No liguilla"
                }
                icon={IconPosition(data?.team?.positions?.data)}
                colorIcon={PaintIcon(data?.team?.positions?.data)}
              />
              <ItemInfo
                title="Pts obtenidos"
                data={data.team.general_table.pts}
                desc={`De ${calculatePointTotal(
                  data.team.general_table.jj
                )} posibles`}
                icon={statusPoints() !== "danger" ? faCaretUp : faCaretDown}
                colorIcon={statusPoints()}
              />
              <ItemInfo
                title="Goles anotados"
                data={data.team.general_table.gf}
                // desc="4 goles/partido"
                desc={`${calculateAverageGoal(
                  data.team.general_table.gf,
                  data.team.general_table.jj
                )} goles/partido`}
                icon={faFutbol}
                colorIcon="success"
              />
              <ItemInfo
                title="Goles recibidos"
                data={data.team.general_table.ge}
                desc={`${calculateAverageGoalAgainst(
                  data.team.general_table.ge,
                  data.team.general_table.jj
                )} goles/partido`}
                icon={faMitten}
                colorIcon="danger"
              />
              <ItemInfo
                title="Triunfos"
                data={data.team.general_table.jg}
                desc="En el torneo"
                icon={
                  data.team.general_table.jp === data.team.general_table.jg
                    ? faMeh
                    : data.team.general_table.jp > data.team.general_table.jg
                    ? faFrown
                    : faGrin
                }
                colorIcon={
                  data.team.general_table.jp === data.team.general_table.jg
                    ? "warning"
                    : data.team.general_table.jp > data.team.general_table.jg
                    ? "danger"
                    : "success"
                }
              />
              <ItemInfo
                title="Empates"
                data={data.team.general_table.je}
                desc="En el torneo"
                icon={faHandsHelping}
                colorIcon="warning"
              />
              <ItemInfo
                title="Derrotas"
                data={data.team.general_table.jp}
                desc="En el torneo"
                icon={
                  data.team.general_table.jp === data.team.general_table.jg
                    ? faMeh
                    : data.team.general_table.jp > data.team.general_table.jg
                    ? faFrown
                    : faGrin
                }
                colorIcon={
                  data.team.general_table.jp === data.team.general_table.jg
                    ? "warning"
                    : data.team.general_table.jp > data.team.general_table.jg
                    ? "danger"
                    : "success"
                }
              />
            </div>
          </div>
          <div className={style.contChartPos}>
            <div className={style.chartPosition}>
              <p className={style.titleSection}>Posiciones por jornadas</p>
              <div className={style.chart}>
                <PositionTeam
                  teamColor={data.team.colorShirt}
                  data={positions()}
                />
              </div>
            </div>
          </div>
          <div className={style.chartStadistic}>
            <CardChart title="Porcentaje de fectividad">
              <EfficiencyTeam
                teamColor={data.team.colorShirt}
                series={calculatePercent()}
              />
            </CardChart>
            <CardChart title="Datos estadísticos">
              <DataTeam
                teamColor={data.team.colorShirt}
                series={[
                  {
                    name: "Dato",
                    data: [
                      data.team.general_table.jg,
                      data.team.general_table.gf,
                      data.team.general_table.ge,
                      redCards(),
                      yellowCards(),
                    ],
                  },
                ]}
              />
            </CardChart>
            {/* <CardChart title="title"></CardChart> */}
          </div>
          <div
            className={
              data.team.players.length > 4
                ? classNames(style.contPlayers, style.marginBottom)
                : style.contPlayers
            }
          >
            <div className={style.head}>
              <p className={style.titleSection}>Jugadores del equipo</p>
              <div className={style.control}>
                <p
                  className={style.titleSection}
                >{`${data.team.players.length} Jugadores`}</p>
                <Link
                  to="/team/players"
                  state={{
                    idTeam: data.team.id,
                  }}
                  className={style.link}
                  style={{
                    background:
                      tinycolor.readability("#17171d", data.team.colorShirt) <=
                      2
                        ? "#00dd80"
                        : "#17171d",
                    border: `1px solid ${data.team.colorShirt}`,
                    color: data.team.colorShirt,
                  }}
                >
                  <FontAwesomeIcon icon={faUsers} />
                </Link>
                {role !== "" &&
                  JSON.parse(team)?.id === data.team.id &&
                  tournaments.data.tournaments[0].registerPlayers &&
                  totalPlayers < 15 && numRegPlayer > 0 && (
                    <Link
                      to="/admin/addplayer"
                      state={{
                        idTeam: data.team.id,
                        nameTeam: data.team.name,
                        color: data.team.colorShirt,
                      }}
                      className={style.link}
                      style={{
                        background:
                          tinycolor.readability(
                            "#17171d",
                            data.team.colorShirt
                          ) <= 2
                            ? "#00dd80"
                            : "#17171d",
                        border: `1px solid ${data.team.colorShirt}`,
                        color: data.team.colorShirt,
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Link>
                  )}
              </div>
            </div>
            <div
              className={
                data.team.players.length > 0 ? style.players : style.noPlayers
              }
            >
              {playersOrder.length > 0 ? (
                playersOrder.map((player) => (
                  <CardPlayer
                    key={player.id}
                    idPlayer={player.id}
                    teamColor={data.team.colorShirt}
                    name={player.name}
                    app={player.app}
                    position={player.position}
                    numShirt={player.numShirt}
                    numRegPlayer={numRegPlayer}
                  />
                ))
              ) : (
                <p className={style.txtMessage}>No hay jugadores registrados</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ItemInfo = ({ title, data, desc, icon, colorIcon }) => (
  <div className={style.contItem}>
    <p className={style.title}>{title}</p>
    <div className={style.contInfo}>
      <p className={style.dataTeam}>{data}</p>
      <p className={classNames(style.icon, style[colorIcon])}>
        {icon ? <FontAwesomeIcon icon={icon} /> : null}
      </p>
    </div>
    <p className={style.desc}>{desc}</p>
  </div>
);

const CardChart = ({ children, title }) => (
  <div className={style.contChart}>
    <p className={style.titleSection}>{title}</p>
    <div className={style.chart}>{children}</div>
  </div>
);

export default DashboardTeam;
